<div class="ui modal"
     id="QR_Modal">
  <button class="circular ui icon button"
          style="float: right;margin: 5px"
          (click)="modalHide()">
    <i class="close icon"></i>
  </button>

  <h2 class="qr-info">
    {{"qr" | t}}
  </h2>

  <div class="qr-box">
    <qrcode [qrdata]="qrCode"
            [width]="320"
            [errorCorrectionLevel]="'M'"></qrcode>

  </div>

  <div *ngIf="errorMessages !== ''" style="background-color: #e7f3fe; border: 1px solid #0e88eb; border-radius: 10px; padding: 10px; margin: 10px">
    {{errorMessages}}
  </div>

</div>
